export default function getCurrentHost() {
  if (window.location.hostname.includes('promopromo')) {
    return 'promopromo'
  } else if (window.location.hostname.includes('myshopi')) {
    return 'myshopi'
  }
  return 'allefolders'
}
